import React from 'react'
import { useLocation } from 'react-router-dom'
import { FiDollarSign } from 'react-icons/fi'

function useQuery() {
  return new URLSearchParams(useLocation().search)
}

const RepresentativeSuccess: React.FC = () => {
  const query = useQuery()
  const orderId = query.get('order_id')
  return (
    <div style={{ padding: 24, maxWidth: 640, margin: '40px auto' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 12 }}>
        <FiDollarSign size={28} color="#48B791" />
        <h2 style={{ margin: 0 }}>
          <strong>Este pedido já foi pago.</strong>
        </h2>
      </div>
      <h3 style={{ marginTop: 0 }}>
        O pedido <b>{orderId}</b> já foi pago.
      </h3>
      <p>
        Caso haja <strong>alguma dúvida</strong>, entre em <strong>contato</strong> com o <strong>seu vendedor</strong>.
      </p>
    </div>
  )
}

export default RepresentativeSuccess
